var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden sm:block",attrs:{"aria-hidden":"true"}},[_c('div',{class:_vm.classObject},[_c('div',{staticClass:"border-t border-gray-200"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }